import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import Apply from "@/pages/Apply";
import Submitted from "@/pages/Submitted";
import Accommodation from "@/pages/Accommodation";
import Privacy from "@/pages/Privacy";
import SelectionCriteria from "@/pages/SelectionCriteria";
import AdminLogin from "@/pages/admin/Login";
import AdminSetup from "@/pages/admin/Setup";
import AdminResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminApplicationDetail from "@/pages/admin/ApplicationDetail";
import AdminSettings from "@/pages/admin/Settings";
import AdminCriteria from "@/pages/admin/Criteria";
import AdminAudit from "@/pages/admin/Audit";
import AdminAccommodations from "@/pages/admin/Accommodations";
import AdminRetention from "@/pages/admin/Retention";
import AdminLaunchChecklist from "@/pages/admin/LaunchChecklist";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/return" element={<Apply />} />
          <Route path="/submitted/:conf" element={<Submitted />} />
          <Route path="/accommodation" element={<Accommodation />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/criteria" element={<SelectionCriteria />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/setup" element={<AdminSetup />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="applications/:id" element={<AdminApplicationDetail />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="criteria" element={<AdminCriteria />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="accommodations" element={<AdminAccommodations />} />
            <Route path="retention" element={<AdminRetention />} />
            <Route path="launch" element={<AdminLaunchChecklist />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
